import { NgModule } from '@angular/core';
import { DatatablesModule, FormsModule, RouteService, SupportModule } from '@kaiser-software/chassis-core';
import { LocationEditPage } from './pages/edit/edit.page';
import { LocationCreatePage } from './pages/create/create.page';
import { LocationIndexPage } from './pages/index/index.page';
import { LocationShowPage } from './pages/show/show.page';

@NgModule({
    imports: [FormsModule, DatatablesModule, SupportModule],
    exports: [],
    declarations: [
        LocationCreatePage,
        LocationEditPage,
        LocationShowPage,
        LocationIndexPage
    ],
    entryComponents: [
        LocationCreatePage,
        LocationEditPage,
        LocationShowPage,
        LocationIndexPage,
    ],
    providers: [],
})
export class LocationsRoutingModule {

    public constructor(protected router: RouteService) {

        // Locations (Storage, Offices, etc.)
        router.add('locations', LocationIndexPage, 'locations.index', {permission: 'location.read'});
        router.add('locations/create', LocationCreatePage, 'locations.create', {permission: 'location.write'});
        router.add('locations/:location', LocationEditPage, 'locations.show', {permission: 'location.write'});
        router.add('locations/:location/edit', LocationEditPage, 'locations.edit', {permission: 'location.write'});
        router.apply();

    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/locations-routing.module.ts